import { useState } from 'react'

import { editorModes } from '@/configuration/pages/ConfigurationPage/CommunicationsConfiguration/EmailTemplates/EmailTemplateDetailConfiguration/EditorModeSelector/constants'

const useCustomHtmlUpsell = ({ mode, smartTrackingEnabled, onChangeMode }) => {
  const [isCustomHtmlUpsellShown, setIsCustomHtmlUpsellShown] = useState(false)

  const handleSelectEditorMode = newMode => {
    const isSameMode = newMode === mode
    const isLockedCustomHtml = newMode === editorModes.liquid && !smartTrackingEnabled

    setIsCustomHtmlUpsellShown(!isSameMode && isLockedCustomHtml)

    if (isSameMode || isLockedCustomHtml) return

    onChangeMode(newMode)
  }

  const handleBackToStandardEditor = () => setIsCustomHtmlUpsellShown(false)

  return {
    selectedEditorMode: isCustomHtmlUpsellShown ? editorModes.liquid : mode,
    isCustomHtmlUpsellShown,
    handleSelectEditorMode,
    handleBackToStandardEditor,
  }
}

export default useCustomHtmlUpsell
